import * as joint from '@clientio/rappid';

import { BasePaper } from './BasePaper';

export class JointJSPaper implements BasePaper {
  constructor(public paper: joint.dia.Paper) {}

  getText(): string {
    return 'JointJSPaper-getText()';
  }
}
